import React, { FC } from 'react'

import styled from 'styled-components'

import { TrackAudioPlayer } from 'src/Components/TrackAudioPlayer'
import TrackCoverDefault from 'src/Assets/Svg/common/track-cover.svg'
import { SmartImage } from 'src/Components/SmartImage'
import { variables } from 'src/Styled/variables'
import { PlayerIcon } from 'src/Components/PlayerIcon'

import { TrackDetailsProps } from '../../index'

export const TrackCoverImage = styled(SmartImage)`
  display: flex;
  width: 68px;
  height: 68px;
  align-items: center;
`

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const TrackImageWrapper = styled.div`
  cursor: pointer;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`

const HighlightedText = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

type Props = Pick<
  TrackDetailsProps,
  'coverUrl' | 'trackName' | 'trackAuthorName' | 'duration' | 'trackPreviewUrl'
>

export const Preview: FC<Props> = ({
  coverUrl,
  trackName,
  trackAuthorName,
  trackPreviewUrl,
  duration,
}) => (
  <Container>
    <TrackAudioPlayer
      render={({ loading, currentTrackUrl, isPlaying, onClick }) => (
        <TrackImageWrapper
          onClick={(e) => {
            onClick(e, trackPreviewUrl)
          }}
        >
          <PlayerIcon
            isLoading={loading && currentTrackUrl === trackPreviewUrl}
            isPlaying={isPlaying}
          />

          <TrackCoverImage
            src={coverUrl}
            fallbackSrc={TrackCoverDefault}
            width={68}
            height={68}
          />
        </TrackImageWrapper>
      )}
    />
    <InfoContainer>
      <div>
        <HighlightedText>{trackName}</HighlightedText>
        <Text>{trackAuthorName}</Text>
      </div>
      <Text>{duration}</Text>
    </InfoContainer>
  </Container>
)
